import {
  logger,
  PanelActionOutcome,
  ActionGesture,
  PanelRegion,
  PanelLaunchMethod,
} from "@mwt/web-js-telemetry";

import {
  ScenarioName,
  ScenarioType,
  ModuleName,
  ModuleSummary,
  PanelType,
} from "../../telemetry/utils/constants";

export function logDevicePermissionEvent(allowed: boolean) {
  logger.logPanelActionEvent({
    actionScenario: ScenarioName.MicCamPermissionPrompt,
    actionScenarioType: ScenarioType.Initialization,
    actionGesture: ActionGesture.Click,
    actionOutcome: allowed
      ? PanelActionOutcome.Enable
      : PanelActionOutcome.Disable,
    moduleName: ModuleName.MicCamAccessPrompt,
    moduleSummary: allowed
      ? ModuleSummary.AllowMicCamAccess
      : ModuleSummary.DenyMicCamAccess,
    panelType: PanelType.AudioTest,
    panelLaunchMethod: PanelLaunchMethod.ActivityFeed,
    panelRegion: PanelRegion.Main,
    panelUri: window.location.pathname,
  });
}
